export default { props: { type: { type: 'enum', values: ['strike'] } } };
//# sourceMappingURL=strike.js.map